import { render, staticRenderFns } from "./DetalleFactura.vue?vue&type=template&id=5970edef&scoped=true&lang=pug&"
import script from "./DetalleFactura.vue?vue&type=script&lang=js&"
export * from "./DetalleFactura.vue?vue&type=script&lang=js&"
import style0 from "./DetalleFactura.vue?vue&type=style&index=0&id=5970edef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970edef",
  null
  
)

export default component.exports